type Props = {
  selected?: boolean;
  text: string;
  onClick: () => void;
};

export const SelectButton = (props: Props) => {
  return (
    <button
      className={`btn ${props.selected ? "selected" : ""}`}
      onClick={props.onClick}
    >
      {props.text}
    </button>
  );
};
